webpackJsonp([255481921002227],{

/***/ 1387:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Marty Nelson","slug":"blog/author/marty-nelson","twitter":"martypdx","linkedIn":null,"website":"","biography":"Marty began his career in enterprise development and was the Head of Architecture at Accelrys (now Biovia) until 2013, and now runs his own consulting company @martypdx, LLC, which focuses on getting startups up and running with their first app or website. His favorite technologies are HTML5, JavaScript, and CSS including 3D transformations and animations. Marty is also a co-maintainer of RactiveJS, a reactive template-driven UI library used by thousands of developers around the globe.","image":{"fields":{"description":"blog-author-marty-nelson.png","file":{"url":"//images.ctfassets.net/k428n7s2pxlu/fhV6WPNwm4OWYg6mcESy0/ffc420157f3cbd944e6db256596b28fb/blog-author-marty-nelson.png"}}}}},"pathContext":{"slug":"blog/author/marty-nelson"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-marty-nelson-cb6d7e858b6cc7974862.js